import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Container, TextField, Button, Typography, Box } from '@mui/material';
import { useParams,useNavigate } from 'react-router-dom';
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';
import { useTranslation } from "react-i18next";

const AcceptInvite = () => {
  const { token } = useParams();
  const navigate = useNavigate(); 
  const [isRegistered, setIsRegistered] = useState(false);
  const [name, setName] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState(''); // Şifre onay alanı
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [userName, setUserName] = useState(''); // Kullanıcı adını göstermek için
  const { t } = useTranslation();
  
  // Şifre kuralları kontrol fonksiyonu
  const validatePassword = (password) => {
    //const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;
    const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/;
    return regex.test(password);
  };

  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  useEffect(() => {
    const checkUserRegistration = async () => {
      try {
        const response = await api.get(`/api/projects/check-user/${token}`);
        
        setIsRegistered(response.data.isRegistered);
        if (response.data.isRegistered) {
          console.log(response.data);
          setUserName(response.data.name); // Kullanıcı adını backend'den alıyoruz
        }
        
      } catch (error) {
        setMessage(t("errorCheckingRegistration", { error: error.response?.data?.error || error.message }));
      }
    };
  
    checkUserRegistration();
  }, [token]);

  const handleGoogleLogin = async (credentialResponse) => {
    setIsSubmitting(true);
    try {
      const { credential } = credentialResponse;
      const response = await api.post(`/api/projects/accept-invite-google/${token}`, { token: credential });
      setMessage(response.data.message);

      setTimeout(() => {
        navigate('/projects');
      }, 2000);
    } catch (error) {
      setMessage(t("googleLoginFailed", { error: error.response?.data?.error || error.message }));
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true); 
    setMessage(''); 

    if (!isRegistered && password !== confirmPassword) {
      setMessage(t("passwordsDoNotMatch"));
      setIsSubmitting(false);
      return;
    }

    if (!isRegistered && !validatePassword(password)) {
      setMessage(t("passwordRequirements"));
      setIsSubmitting(false);
      return;
    }

    try {
      const payload = isRegistered ? { password } : { name, password }; 
      const response = await api.post(`/api/projects/accept-invite/${token}`, payload);

      setMessage(response.data.message);
      // Davetiye kabul edildikten sonra login sayfasına yönlendir
      setTimeout(() => {
        navigate('/login');  // Login sayfasına yönlendiriyoruz
      }, 2000);  // 2 saniye sonra yönlendirme işlemi yapılacak
    } catch (error) {
      setMessage(t("operationFailed", { error: error.response?.data?.error || error.message }));
    } finally {
      setIsSubmitting(false); 
    }
  };

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
    <Container maxWidth="sm">
  <Box mt={5}>
    <Typography variant="h4" gutterBottom>
      {isRegistered ? t("loginToAccept") : t("registerToAccept")}
    </Typography>
    <form onSubmit={handleSubmit}>
      {isRegistered && (
        <Typography variant="h6" gutterBottom>
          {t("welcomeBack", { user: userName })}
        </Typography>
      )}

      {!isRegistered && (
        <TextField
          label={t("name")}
          fullWidth
          margin="normal"
          value={name}
          onChange={(e) => setName(e.target.value)}
          required
        />
      )}
      <TextField
        label={t("password")}
        type="password"
        fullWidth
        margin="normal"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
        helperText={!isRegistered ? t("passwordRequirements") : ""}
      />
      {!isRegistered && (
        <TextField
          label={t("confirmPassword")}
          type="password"
          fullWidth
          margin="normal"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
      )}
      <Button
        variant="contained"
        color="primary"
        type="submit"
        fullWidth
        disabled={isSubmitting}
      >
        {isSubmitting ? t("processing") : isRegistered ? t("logIn") : t("register")}
      </Button>
    </form>
    <Box mt={3} textAlign="center">
      <Typography variant="body1" sx={{ mb: 2 }}>
        {t("acceptWithGoogle")}
      </Typography>
      <GoogleLogin
        onSuccess={handleGoogleLogin}
        onError={() => setMessage(t("googleLoginFailed"))}
      />
    </Box>
    {message && <Typography color="error" mt={2}>{message}</Typography>}
  </Box>
</Container>;
    </GoogleOAuthProvider>
  );
};

export default AcceptInvite;
